function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.981 0C.441 0 0 .44 0 .981c0 .54.44.981.981.981h2.177l2.575 10.3c.218.874 1 1.472 1.9 1.472h12.232a1.93 1.93 0 001.87-1.44l2.545-9.351h-2.054l-2.36 8.829H7.632l-2.575-10.3A1.945 1.945 0 003.158 0H.98zm17.658 13.734a2.959 2.959 0 00-2.943 2.943 2.959 2.959 0 002.943 2.943 2.959 2.959 0 002.943-2.943 2.959 2.959 0 00-2.943-2.943zm-8.829 0a2.959 2.959 0 00-2.943 2.943A2.959 2.959 0 009.81 19.62a2.959 2.959 0 002.943-2.943 2.959 2.959 0 00-2.943-2.943zm0 1.962c.552 0 .981.43.981.981 0 .552-.43.981-.981.981a.968.968 0 01-.981-.981c0-.552.43-.981.981-.981zm8.829 0c.552 0 .981.43.981.981 0 .552-.43.981-.981.981a.968.968 0 01-.981-.981c0-.552.43-.981.981-.981z",
  fill: "#05405B"
});

function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    fill: "none"
  }, props), _ref);
}

export default SvgBasket;